import { useContext, useEffect, useState } from 'react';
import { Text, View } from 'react-native';
import { Divider } from 'react-native-paper';
import { Button, TouchableRipple } from "react-native-paper";
import { Image } from "react-native";
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { GET_TEMPLATES } from '../../templates/graphql/query';
import { API_KEYS_BY_GROUP } from '../../profile/graphql/query';
import { DropdownComponent } from '../../../components/forms/DropdownComponent';
import { ChecksDropdownComponent } from '../../../components/forms/ChecksDropdownComponent';
import React from 'react';
import { ACTIVE_GROUP } from '../../profile/graphql/mutation';
import UserContext from '../../../../context/user/UserContext';

interface HeaderAppProps {
    onHandleResetChat: () => void;
    onHandleSelectTemplate: any;
    template?: any;
    setPlaceholderTemplateApp?: any;
    placeholderTemplateApp?: any;
    setGeneralPrompt?: any;
    setModelsSelected?: any;
    defaultModels?: any;
}

export default function HeaderApp({ onHandleResetChat, onHandleSelectTemplate, template, setPlaceholderTemplateApp, placeholderTemplateApp, setGeneralPrompt, setModelsSelected, defaultModels }: HeaderAppProps) {


    const { userState } = useContext(UserContext);

    const { data: dataTemplates, loading: loadingTemplates, error: errorTemplates } = useQuery(GET_TEMPLATES);
    const [getModels, { data: dataModels, loading: loadingModels, error: errorModels }] = useLazyQuery(API_KEYS_BY_GROUP);

    const [setActiveGroup, { data: dataActiveGroup, loading: loadingActiveGroup, error: errorActiveGroup }] = useMutation(ACTIVE_GROUP);

    const [groups, setGroups] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [models, setModels] = useState([] as any);

    const [groupSelected, setGroupSelected] = useState('');
    const [selectedModels, setSelectedModels] = useState([] as any);

    const [placeholderModel, setPlaceholderModel] = useState("Selecciona un modelo");

    const handleSelectGroup = async (item: any) => {

        // hacemos su grupo activo
        await setActiveGroup({ variables: { groupId: item.value } });

        window.location.reload();
    }

    const handleSelectTemplate = (item: any) => {

        setPlaceholderTemplateApp(item.label);
        setGeneralPrompt(item.data.instructions + ", " + item.data.output);
        onHandleSelectTemplate(item.data.instructions, item.data.output, item.value, item.label);

    }

    const handleSelectModel = async (item: any) => {

        let selected = selectedModels.find((element: any) => element[0] === item[0]);

        if (selected) {
            setSelectedModels(selectedModels.filter((element: any) => element[0] !== item[0]));
            setModelsSelected(selectedModels.filter((element: any) => element[0] !== item[0]));
        }
        else {
            if (selectedModels.length < 3) {
                setSelectedModels([...selectedModels, item]);
                setModelsSelected([...selectedModels, item]);
            }
        }

    }

    const handleResetChat = () => {
        setPlaceholderTemplateApp("Selecciona un template");
        onHandleResetChat();
    }

    useEffect(() => {

        if (dataTemplates) {
            setTemplates(dataTemplates?.templetesRecent?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.id,
                    data: {
                        instructions: item.instructions,
                        output: item.output
                    }
                }
            }))
        }

        if (template?.name) {
            setPlaceholderTemplateApp(template.name);
        }

    }, [dataTemplates, template]);

    useEffect(() => {

        if (userState?.dataUser?.groups) {
            setGroups(userState.dataUser.groups.map((item: any) => {
                return {
                    label: item.name,
                    value: item.id
                }
            }));

            setGroupSelected(userState.dataUser.groupActiveId ? userState.dataUser.groups.find((item: any) => item.id === userState.dataUser.groupActiveId).name : "Selecciona un grupo");

        }

        if (userState?.dataUser?.activeApiKeys.length > 0) {

            if (defaultModels.length != 0) {

                setSelectedModels(defaultModels.map((item: any) => {
                    return [item.id]
                }));
                setModelsSelected(defaultModels.map((item: any) => {
                    return [item.id]
                }));

                let place = "";
                defaultModels.forEach((element: any) => {
                    let name: any = models.find((model: any) => model.value === element.id);
                    if (name)
                        place += name.label + ", ";
                }
                );

                // quitamos la ultima coma
                place = place.substring(0, place.length - 2);

                setPlaceholderModel(place);

                return;
            }

            // poner el modelo activo
            if (selectedModels.length === 0) {

                setSelectedModels(userState?.dataUser?.activeApiKeys.length > 0 ? userState?.dataUser?.activeApiKeys.map((item: any) => [item.id]) : []);
                setModelsSelected(userState?.dataUser?.activeApiKeys.length > 0 ? userState?.dataUser?.activeApiKeys.map((item: any) => [item.id]) : []);

                let place = "";
                userState?.dataUser?.activeApiKeys.forEach((element: any) => {
                    const name = element.name;
                    if (name)
                        place += name + ", ";
                }
                );

                place = place.substring(0, place.length - 2);

                setPlaceholderModel(place);
            }

            (async () => {

                // insertamos los modelos (apiKeys)
                const { data: dataModels } = await getModels();
                setModels(dataModels.apiKeysByGroup.map((item: any) => {
                    return {
                        label: item.name,
                        value: item.id
                    }
                }))
            })();


        }

    }, [userState]);

    useEffect(() => {
        let place = "";

        if (selectedModels.length === 0) {
            setPlaceholderModel("Selecciona un modelo");

            return;
        }


        if (selectedModels.length > 0 && models.length > 0) {
            selectedModels.forEach((element: any) => {
                let name: any = models.find((model: any) => model.value === element[0]);
                if (name)
                    place += name.label + ", ";
            }
            );

            place = place.substring(0, place.length - 2);

            setPlaceholderModel(place);
        }

    }, [selectedModels]);

    useEffect(() => {
        if (defaultModels.length != 0) {

            setSelectedModels(defaultModels.map((item: any) => {
                return [item.id]
            }));
            setModelsSelected(defaultModels.map((item: any) => {
                return [item.id]
            }));

            let place = "";
            defaultModels.forEach((element: any) => {
                let name: any = models.find((model: any) => model.value === element.id);
                if (name)
                    place += name.label + ", ";
            }
            );

            // quitamos la ultima coma
            place = place.substring(0, place.length - 2);

            setPlaceholderModel(place);

            return;
        }
    }, [defaultModels]);


    return (
        <View className="md:flex w-[100%] flex-col justify-center items-center">
            <View className="flex items-center justify-center  md:justify-between flex-row md:mt-3" style={{ width: "80%" }}>
                <View className="flex flex-row items-center justify-between">
                    <Text className="text-white text-base font-semibold mr-3">Grupo </Text>
                    {
                        loadingActiveGroup ? (
                            <View className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white" />
                        ) : (

                            <View className=" w-56">
                                <DropdownComponent
                                    data={groups}
                                    onChange={handleSelectGroup}
                                    placeholder={groupSelected}

                                />
                            </View>
                        )
                    }

                </View>


                <View className="hidden md:flex flex-row items-center justify-center">
                    <Text className="text-white text-base font-semibold mr-3">Template </Text>
                    {
                        loadingActiveGroup || loadingModels || loadingTemplates ? (
                            <View className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white" />

                        ) : (
                            <View className=" w-56">

                                <DropdownComponent
                                    data={templates}
                                    onChange={handleSelectTemplate}
                                    placeholder={placeholderTemplateApp}
                                />

                            </View>
                        )
                    }

                </View>

                <View className="hidden md:flex flex-row items-center justify-center">
                    <Text className="text-white text-base font-semibold mr-3">Modelo </Text>

                    {
                        loadingActiveGroup || loadingModels || loadingTemplates ? (
                            <View className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white" />

                        ) : (
                            <View className=" w-56">

                                <ChecksDropdownComponent
                                    data={models}
                                    onChange={handleSelectModel}
                                    placeholder={placeholderModel}
                                    selectedItems={selectedModels}
                                />

                            </View>
                        )
                    }

                </View>


                <View className="flex justify-center items-center">

                    <Button
                        mode="text"
                        onPress={handleResetChat}

                        className="hover:transform hover:scale-110 transition duration-100 ease-in-out"
                    >
                        <TouchableRipple
                            onPress={handleResetChat}
                        >
                            <Image
                                source={require('../../../../assets/refresh.svg')}
                                style={{ width: 25, height: 25 }}
                                tintColor={"#D9D9D9"}
                            />
                        </TouchableRipple>
                    </Button>

                </View>

            </View>


            <View style={{ width: "100%" }} className="mt-3">
                <Divider bold className="text-white" />
            </View>
        </View>

    )
}